module.exports = __webpack_public_path__ + "static/media/projects.9d0ca1de.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/features/projects.mp4
// module id = 369
// module chunks = 0